Hop.defineModule('onloadTracking', (root, param) => {
    const gtmTracking = param.gtmTracking;

    function addTracking() {
        Hop.gtm.push(gtmTracking);
    }

    window.onload = addTracking();
});
